export default (amount: number) => {
  return amount === 0 ? amount : amount - 1
}
